"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConversationOutputDtoSchema = exports.getConversationInputDtoSchema = void 0;
const zod_1 = require("zod");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
exports.getConversationInputDtoSchema = zod_1.z.object({
    conversationId: conversation_summary_dto_js_1.agentChatConversationIdSchema,
    ownerId: conversation_summary_dto_js_1.agentChatConversationOwnerIdSchema.optional(),
    includeRelations: zod_1.z.boolean().optional().describe('Include direct parent and child conversation summaries.'),
});
exports.getConversationOutputDtoSchema = conversation_summary_dto_js_1.conversationSummaryDtoSchema
    .extend({
    ownerId: conversation_summary_dto_js_1.agentChatConversationOwnerIdSchema,
    canInteract: zod_1.z.boolean(),
    parentConversation: conversation_summary_dto_js_1.conversationSummaryDtoSchema.nullable(),
    childConversations: conversation_summary_dto_js_1.conversationSummaryDtoSchema.array(),
})
    .nullable();
//# sourceMappingURL=get-conversation.dto.js.map